import React, { useState} from "react";
import Pagination from "@mui/material/Pagination";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import CssBaseline from '@mui/material/CssBaseline';

import { useStyles } from "./styles";

const StyledPagination = ({limit, offset, total_count, handleChange, handleChangeLimit,pageSizes=[10,50,100],className="pagination",showOnlyOnMultiple=false }) => {
  const [itemsPerPage, setItemsPerPage] = useState(limit);
  const classes = useStyles();
  const { paginationContainer, pageListformControl, pageCountSection, styledPagination} = classes;

  const handleItemsPerPage = event => {
    setItemsPerPage(event.target.value);
    handleChangeLimit(event.target.value);
  };

  const handlePageChange = (e,page) => {
    if (currentPage === page) {
      return;
    }
    const pagination = { offset: (page - 1)*limit,page};
    handleChange(pagination);
  };
  const currentPage = offset/limit + 1;
  const currentFirstItem = offset + 1;
  const currentLastItem = parseFloat(total_count) - parseFloat(offset) < limit ? parseFloat(total_count) : parseFloat(itemsPerPage) + parseFloat(offset);
  const totalPages = Math.ceil(total_count/limit)
  const show = !showOnlyOnMultiple || totalPages>1;
  return (show?
    <div className={`${paginationContainer} ${className} single-page-${!handleChangeLimit && totalPages ==1}`}>
      <div className={classes.pagination}>
        <CssBaseline />
            <Pagination
              className={styledPagination}
              page={currentPage}
              count={totalPages}
              boundaryCount={2}
              onChange={handlePageChange}
              //reduced={true}
            />
      </div>
      {handleChangeLimit && <div className={`${pageCountSection} pageSizeCtr`}>
        <span className={classes.itemPerPageTxt}>Items per page</span>
        <FormControl variant="outlined" className={pageListformControl}>
          <Select
            value={itemsPerPage || ""}
            input={<OutlinedInput labelWidth={75} name="age" id="outlined-age-simple" onChange={handleItemsPerPage} />}
            className={classes.selectBox}
          >
            {pageSizes.map(s=><MenuItem key={s} value={s}>{s}</MenuItem>)}
          </Select>
        </FormControl>
        <span>
          {currentFirstItem}-{currentLastItem} of {total_count}
        </span>
      </div>}
    </div>
  :'');
};

export default StyledPagination;
